import { render, staticRenderFns } from "./DashboardReportCustomer.vue?vue&type=template&id=f97cc836&scoped=true&"
import script from "./DashboardReportCustomer.vue?vue&type=script&lang=js&"
export * from "./DashboardReportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97cc836",
  null
  
)

export default component.exports